<template>
  <button class="btn btn-sm btn-outline-default border-0 bg-light-gray" @click="deleteTask" title="Delete task">
    <i v-if="isDeleting" class="fa fa-spinner fa-spin text-dark"></i>
    <font-awesome-icon v-else icon="trash-can" />
  </button>
</template>

<script>
import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';

export default {
  name: "DeleteTaskButton",
  props: {
    taskId: String,
  },
  data() {
    return {
      isDeleting: false
    }
  },
  methods: {
    async deleteTask() {
      this.isDeleting = true;
      try {
        await ziperase.deleteTask(this.taskId);
        await this.$store.dispatch('task/fetchTasks');
      } catch (error) {
        notify().error('Failed to delete task.');
        this.isDeleting = false;
      }
    }
  }
};
</script>
